import { render, staticRenderFns } from "./ReguaList.vue?vue&type=template&id=5f50197e"
import script from "./ReguaList.vue?vue&type=script&lang=js"
export * from "./ReguaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports